import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';

// Authentication Module
import Forget from './auth/forgetpwd/reducer';
import Login from './auth/login/reducer';

//Calendar 
import Calendar from "./calendar/reducer";
import Clinic from "./clinic/reducer";
import Holiday from "./holiday/reducer";
import Teleconsult from "./teleconsult/reducer";
import Doctor from "./doctor/reducer";
import Dashboard from "./dashboard/reducer";
import General from "./general/reducer";
import Patients from "./patients/reducer";
import Appointments from "./appointments/reducer";
import MaybankAppointments from "./maybank/reducer";
import Profile from "./profile/reducer";
import Role from "./role/reducer";
import User from "./user/reducer";
import packagesModule from "./packages/module";
import packageBookingsModule from "./packageBookings/module";
import campaignsModule from "./campaigns/module";
import testimonialResponsesModule from "./testimonialResponses/module";

//chat
import chat from "./chat/reducer";

const rootReducer = combineReducers({
    Layout,
    // public
    // Authentication
    Login,
    Forget,
    Teleconsult,
    Calendar,
    General,
    Patients,
    Appointments,
    MaybankAppointments,
    Clinic,
    Holiday,
    Doctor,
    Dashboard,
    User,
    [packagesModule.stateKey]: packagesModule.reducer,
    [packageBookingsModule.stateKey]: packageBookingsModule.reducer,
    [campaignsModule.stateKey]: campaignsModule.reducer,
    [testimonialResponsesModule.stateKey]: testimonialResponsesModule.reducer,
    Profile,
    Role,
    chat,

});

export default rootReducer;
